import base from "./env";

const conf = Object.assign({}, base, {
  APP_ID: "comicicomics",
  CONTENT_ID: 7,
  LOG_SITE_NAME: "comicicomics",

  GTM_ID_DEV: "GTM-WWLV69",
  GTM_ID_PROD: "GTM-KH8JDCVN",

  DASHBOARD_DOMAIN: "dashboard.mangazine.comici.jp",

  // SHARE
  SHARE_HASHTAG: "#コミチコミックス",
  SHARE_USER: "@comici_jp",

  //viewer
  VIEWER_AD_ID: "",

  // お問い合わせ
  HELP_URL: "https://support.comici.jp/hc/ja",
  HELP_PATH_COIN: "/categories/5500146021775-コインついて",

  //初めての方へページがあるかどうか
  HAS_TUTORIAL_PAGE: false,
  IS_RENTAL: false,

  //ガチャページをON
  HAS_GACHA_PAGE: true,
  //ミッション機能をON
  HAS_MISSION: true,
});

conf.VIEWER_API_DOMAIN_PREFIX = conf.VIEWER_API_DOMAIN_PREFIX.replace(".", "-");

export default conf;
